import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import { ReactSession } from "react-client-session";
import { transitions, positions, Provider as AlertProvider } from 'react-alert'
import AlertTemplate from 'react-alert-template-basic'
import "react-confirm-alert/src/react-confirm-alert.css";
import { Helmet } from 'react-helmet';

const root = ReactDOM.createRoot(document.getElementById('root'));

ReactSession.setStoreType("localStorage");

const optionsMessage = {
  position: positions.BOTTOM_CENTER,
  timeout: 5000,
  offset: "30px",
  transition: transitions.SCALE,
};

root.render(
  <>
    <Helmet>
      <meta charSet="utf-8" />
      <meta name="keywords" content="OIC" />
      <meta name="description" content="OIC" />
      <meta name="author" content="Victor Hugo Dominguez Perez" />
      <link rel="shortcut icon" href="favicon.ico" type="image/x-icon" />
      <link rel="apple-touch-icon" href="favicon.ico" type="image/x-icon" />
    </Helmet>
    <BrowserRouter basename="/">
      <AlertProvider template={AlertTemplate} {...optionsMessage}>
        <App />
      </AlertProvider>
    </BrowserRouter>
  </>
);